export default __webpack_public_path__ + "static/media/6-1_signout.bf3cfed6.svg";